import { createApp } from 'vue'
// import ProfileMainPage from './components/biobrowser/profile/ProfileMainPage.vue';
import MainPage from '@/views/SpeciesProfile.vue';
import loadI18n from './i18n'
// createApp(App).mount('#app')
/* eslint-disable no-new */
import VTooltip from 'v-tooltip';
import 'v-tooltip/dist/v-tooltip.css';
/* highchart only needs to be registered once,
if mulitple registered occure, some charts will show as blank.
 */

import Highcharts from 'highcharts';
// Load the exporting module.
import Exporting from 'highcharts/modules/exporting';
// load more to render error bars
import HighchartMore from 'highcharts/highcharts-more';
import HighchartsGroupedCategories from 'highcharts-grouped-categories'

HighchartMore(Highcharts);
// Initialize exporting module.
Exporting(Highcharts);
HighchartsGroupedCategories(Highcharts);
/* end highchart registration */
const domId = 'species-profile-app';

document.addEventListener('DOMContentLoaded', async function () {
  // const body = document.querySelector('body');
  // const year = +body.dataset.year;

  if (document.getElementById(domId)) {
    const app = createApp(MainPage); //, { year });
    app.use(VTooltip);
    const i18n = await loadI18n();
    app.use(i18n);
    app.mount('#' + domId);
  }
});
